import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { media } from '@clds/style-utils';
import { ButtonLink } from '@cld/button';

export const MenuRoot = styled.div<{ forceVisible: boolean }>`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;

  // Force visibility because of use of React portals
  ${(props) =>
    props.forceVisible &&
    css`
      opacity: 1 !important;

      svg {
        opacity: 1 !important;
      }
    `}

  ${ButtonLink} {
    &:not(:first-of-type) {
      margin-left: ${globalTheme.spacing.xxs};
    }
  }

  @media ${media.phone()} {
    // Move it to top of the card on mobile
    order: -1;
  }
`;
